import { JSX } from "react";
import { NavLink } from "react-router";

type Props = {
  title: string;
  link: string;
  icon: JSX.Element;
};
export default function SideBarButtons({
  title,
  link,
  icon,
}: Props): JSX.Element {
  return (
    <NavLink
      to={link}
      style={{
        color: "black",
        textDecoration: "None",
      }}>
      <div className="icon-navigation">
        <div className="icon-navigation-wrapper">{icon}</div>
        {title}
      </div>
    </NavLink>
  );
}
